/**
 * Selector de tienda.
 *
 * Solo lista las tiendas que el servidor confirmo como accesibles (ver
 * `StoreAccessProvider`). Si el usuario no tiene ninguna concedida, el estado
 * vacio lo dice sin rodeos y nombra la tabla que hay que tocar: un operador que
 * ve "no tenes tiendas" sin saber por que no puede hacer nada.
 */

import { ErrorState, Spinner } from "../components/Feedback";
import { useStoreAccess } from "./StoreAccessProvider";

export function StoreSelector() {
  const { state, selected, selectStore, reload } = useStoreAccess();

  if (state.kind === "loading" || state.kind === "idle") {
    return <Spinner label="Resolviendo tiendas..." />;
  }

  if (state.kind === "error") {
    return <ErrorState error={state.error} onRetry={reload} />;
  }

  if (state.data.length === 0) {
    return (
      <p className="store-selector__empty">
        Tu usuario no tiene ninguna tienda concedida. Un administrador tiene que
        darte acceso en la tabla <code>user_store_access</code>.
      </p>
    );
  }

  return (
    <label className="store-selector">
      <span className="store-selector__label">Tienda</span>
      <select
        value={selected?.id ?? ""}
        onChange={(event) => selectStore(Number.parseInt(event.target.value, 10))}
      >
        {state.data.map((store) => (
          <option key={store.id} value={store.id}>
            {store.name}
            {store.is_active ? "" : " (inactiva)"}
          </option>
        ))}
      </select>
    </label>
  );
}
